import { useUserPhoneFromBrazeQuery } from 'generated/rbi-graphql';
import { useLocationContext } from 'state/location';

import { BRAZE_ID_PARAM } from './constants';

const usePhoneFromBrazeId = (): string => {
  const { location } = useLocationContext();
  const { search } = location;
  const queryParams = new URLSearchParams(search);
  const brazeId = queryParams.get(BRAZE_ID_PARAM) ?? '';

  const { data } = useUserPhoneFromBrazeQuery({
    variables: {
      brazeId,
    },
    skip: !brazeId,
  });

  return data?.userPhoneFromBraze?.phone ?? '';
};

export default usePhoneFromBrazeId;
